import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Dimmer, Loader } from 'semantic-ui-react';
import { useProducts } from '../../../providers/ProductProvider';
import { AddButton } from '../../../components/AddButton/AddButton';
import { useAuth } from '../../../providers/AuthenticationProvider';
const WEB_PAGE = 'Products';

export const Products = () => {
    const [loading, setLoading] = useState(true);
    const { getProducts, productsList, total, pageIndex, pageSize, sortState, setPageIndex, setPageSize, setSortState } = useProducts();
    const { isSystemAdmin, checkAuth, getUserType } = useAuth();
    const navigate = useNavigate();

    checkAuth(getUserType(), WEB_PAGE) && navigate('/');

    useEffect(() => {
        setLoading(true);
        const fetchProducts = async () => {
            await getProducts();
            setLoading(false);
        }

        fetchProducts();
    }, [getProducts]);

    const handlePageChange = (e) => {
        setPageIndex(e.page.skip / e.page.take);
    };

    const handleSortChange = (e) => {
        setSortState(e.sort.length ? [{ fieldName: e.sort[0].field, dir: e.sort[0].dir }] : []);
    };

    const sort = sortState.map(s => ({ field: s.fieldName, dir: s.dir }));

    return (
        <div>
            <div className="pageHeader">
                <h1>Products</h1>
                <AddButton to="/products/create-product">Create a Product</AddButton>
            </div>
            <div style={{ position: 'relative' }}>
                <Dimmer active={loading} inverted>
                    <Loader />
                </Dimmer>
                <Grid
                    data={productsList}
                    total={total}
                    skip={pageIndex * pageSize}
                    take={pageSize}
                    pageable={true}
                    sortable={true}
                    sort={sort}
                    onPageChange={handlePageChange}
                    onSortChange={handleSortChange}
                    onRowClick={(e) => navigate(`/products/${e.dataItem.id}`)}
                >
                    <Column field="name" title="Name" />
                    {isSystemAdmin() ? <Column field="componentId" title="Component Id" width={150} cell={props => <td>{props.dataItem.componentId ?? ''}</td>} /> : null}
                    <Column
                        field="distributorId"
                        title="Provider"
                        width={150}
                        cell={props => <td>{props.dataItem.distributorId ? props.dataItem.distributor?.name : 'Pathian'}</td>}
                    />
                    <Column field="type" title="Type" width={130} cell={props => <td>{props.dataItem.type ?? ''}</td>} />
                    <Column field="occurrence" title="Occurrence" width={140} cell={props => <td>{props.dataItem.occurrence ?? ''}</td>} />
                    <Column
                        field="price"
                        title="Price"
                        width={120}
                        cell={props => (
                            <td style={{ textAlign: 'right' }}>
                                {props.dataItem.price.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                            </td>
                        )}
                    />
                    <Column field="units" title="Units" width={110} cell={props => <td>{props.dataItem.units ?? ''}</td>} />
                    <Column
                        field="enabled"
                        title="Enabled"
                        sortable={false}
                        width={110}
                        cell={props => (
                            <td style={{ color: props.dataItem.enabled ? '#16ab39' : '#d01919' }}>
                                {props.dataItem.enabled ? 'Enabled' : 'Disabled'}
                            </td>
                        )}
                    />
                </Grid>
            </div>
        </div>
    );
};
